<ng-container *transloco="let t">
  <app-grid-page [title]="t('alerts.title')">
    @if (activeTab() === 'rules') {
      <app-grid
        [columns]="ruleColumns()"
        [data]="pagedRules()"
        [rowId]="ruleId"
        [loading]="isRulesLoading()"
        [page]="rulesPage()"
        [pageSize]="rulesSize()"
        [totalElements]="rules().length"
        [totalPages]="rulesTotalPages()"
        [tabs]="tabs()"
        [activeTabId]="activeTab()"
        [primaryAction]="
          isAdmin() && options()
            ? { label: t('alerts.rules.addRule'), icon: 'icon-content-add24px' }
            : null
        "
        [rowActions]="ruleRowActions()"
        (tabChange)="onTabChange($event)"
        (pageChange)="onRulesPageChange($event)"
        (pageSizeChange)="onRulesPageSizeChange($event)"
        (rowActionClick)="onRuleAction($event)"
        (primaryActionClick)="openAddRule()"
      >
        <!-- The grid's generic is erased in this host template, so `row`
             arrives as `unknown`; `asRule` locks it back to AlertRule. -->
        <ng-template gridCell="enabled" let-row>
          @let toggleRule = asRule(row);
          <app-toggle
            [ngModel]="toggleRule.enabled"
            [disabled]="!isAdmin()"
            (ngModelChange)="onToggleEnabled(toggleRule, $event)"
          ></app-toggle>
        </ng-template>

        <ng-template gridCell="openAlerts" let-row>
          @let countRule = asRule(row);
          @if (firingCountFor(countRule.id) > 0) {
            <span class="inline-flex items-center gap-2 text-ink-1">
              <app-badge color="red" [count]="firingCountFor(countRule.id)" />
              {{ t('alerts.rules.firingCount', { count: firingCountFor(countRule.id) }) }}
            </span>
          } @else {
            <span class="text-ink-3">{{ t('alerts.dash') }}</span>
          }
        </ng-template>
      </app-grid>
    } @else if (activeTab() === 'delivery') {
      <!-- One row per channel that has attempted a delivery — no paging. -->
      <app-grid
        [columns]="deliveryColumns()"
        [data]="deliveryStatuses()"
        [rowId]="deliveryId"
        [loading]="isDeliveryLoading()"
        [totalElements]="deliveryStatuses().length"
        [totalPages]="1"
        [tabs]="tabs()"
        [activeTabId]="activeTab()"
        (tabChange)="onTabChange($event)"
      >
        <ng-template gridCell="lastError" let-row>
          @let delivery = asDelivery(row);
          @if (delivery.lastError; as lastError) {
            <!-- Verbatim backend error — mono, like a log line. -->
            <span class="truncate font-mono text-[13px] text-ink-2" [title]="lastError">
              {{ lastError }}
            </span>
          } @else {
            <span class="text-ink-3">{{ t('alerts.dash') }}</span>
          }
        </ng-template>
      </app-grid>
    } @else {
      <app-grid
        [columns]="alertColumns()"
        [data]="alerts()"
        [rowId]="alertId"
        [loading]="isAlertsLoading()"
        [page]="page()"
        [pageSize]="size()"
        [totalElements]="totalElements()"
        [totalPages]="totalPages()"
        [tabs]="tabs()"
        [activeTabId]="activeTab()"
        [rowActions]="alertRowActions()"
        (tabChange)="onTabChange($event)"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (rowActionClick)="onAlertAction($event)"
      >
      </app-grid>
    }
  </app-grid-page>

  @if (isRuleDialogOpen() && options(); as ruleOptions) {
    <app-rule-dialog
      [options]="ruleOptions"
      [rule]="editingRule()"
      (closed)="closeRuleDialog()"
      (saved)="onRuleSaved()"
    ></app-rule-dialog>
  }
</ng-container>
